import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { ElementType, HTMLAttributes, MouseEventHandler } from 'react';

export interface IconItemProps extends HTMLAttributes<HTMLElement> {
  tag?: ElementType;
  icon?: IconProp;
  bg?: string;
  size?: string;
  color?: string;
  className?: string;
  transform?: string;
  iconClass?: string;
  onClick?: MouseEventHandler<HTMLElement>;
}

const IconItem = ({
  tag: Tag = 'a',
  icon,
  bg,
  size,
  color,
  className,
  transform,
  iconClass,
  onClick,
  ...rest
}: IconItemProps) => (
  <Tag
    className={classNames(className, 'icon-item', {
      [`icon-item-${size}`]: size,
      [`bg-${bg}`]: bg,
      [`text-${color}`]: color,
    })}
    {...rest}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon ?? 'circle'} transform={transform} className={iconClass} />
  </Tag>
);

export default IconItem;
